import store from '../../store';

/**
 * 校验按钮是否有权限
 * @param {*} el  当前绑定按钮
 * @param {*} binding 绑定属性  binding.arg 存在且为'disabled',代表按钮没有权限时，不可用，且置灰显示，反之无权限，按钮隐藏
 */

function checkPermission(el, binding) {
  const { value } = binding;

  const perms = store.getters && store.state.permission.btnDatas;
  
  //const perms = this.$store.getters["permission/getBtnDatas"];

  if (value) {
    if (value.length > 0 && !perms[value]) {
      if (binding.arg && binding.arg === 'disabled') {
        el && el.setAttribute('disabled', 'disabled');
        el && el.classList.add('is-disabled');
      } else {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  } else {
    throw new Error(`权限未配置`);
  }
}

export default {
  //当绑定元素插入到DOM中时
  inserted(el, binding) {
    checkPermission(el, binding);
  },
  update(el, binding) {
    checkPermission(el, binding);
  }
};
